import React from "react";
import { useTranslation } from "@onefront/react-sdk";
import { StickyFooter } from "../../../stickyfooter";
import { Button, CircularProgress, Stack } from "@vapor/react-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";

export const BusinessFooterForm = ({
    onForward,
    onBack,
    disabledForward,
    loading,
    isNewBusiness,
    lastStep
}: {
    onForward: () => void;
    onBack: () => void;
    disabledForward: boolean;
    loading: boolean;
    isNewBusiness: boolean;
    lastStep?: boolean;
}) => {
    const { t } = useTranslation();

    if (!isNewBusiness) {
        return (
            <Stack pt={4} spacing={2} direction="row">
                <Button style={{ width: 92 }} size="small" variant="outlined" onClick={onBack}>
                    <>{t("general.cancel")}</>
                </Button>
                <Button
                    style={{ width: 86 }}
                    size="small"
                    variant="contained"
                    disabled={disabledForward}
                    onClick={onForward}
                >
                    {loading && <CircularProgress size={14} style={{ marginRight: 8 }} color="inherit" />}
                    <>{t("general.save")}</>
                </Button>
            </Stack>
        );
    }

    return (
        <StickyFooter width={"70%"}>
            <Stack spacing={2} direction={"row"}>
                <Button
                    variant="text"
                    size="large"
                    onClick={onBack}
                    sx={{
                        width: "fit-content",
                        padding: "0 2rem",
                        boxSizing: "content-box"
                    }}
                >
                    <FontAwesomeIcon icon={faChevronLeft} style={{ marginRight: "1rem" }} />
                    {!isNewBusiness ? <>{t("general.cancel")}</> : <>{t("general.back")}</>}
                </Button>
                <Button
                    variant="contained"
                    onClick={onForward}
                    size="large"
                    sx={{
                        width: "fit-content",
                        padding: "0 28px",
                        boxSizing: "content-box"
                    }}
                    disabled={disabledForward}
                >
                    <>
                        {loading && <CircularProgress size={20} style={{ marginRight: 8 }} color="inherit" />}

                        {lastStep ? <>{t("general.save_and_conclude")}</> : <>{t("general.forward")}</>}
                    </>
                </Button>
            </Stack>
        </StickyFooter>
    );
};
